import { ComponentDefinition, isLabeledComponentDefinition } from "components/components/Component";
import "datatables.net";
import { Table } from "../table";
import { ColumnDefinition } from "./ColumnDefinitions";
import { ColumnFactory } from "./ColumnFactory";

export class ComponentColumn implements DataTables.ColumnDefsSettings {
    public className = "c-datatable__component-column-cell";
    public targets: number;
    public property: string;
    public name: string;
    private definition: ComponentColumnDefinition;
    public orderable = true;
    private table: Table;

    constructor(column, definition: ComponentColumnDefinition, table: Table) {
        this.table = table;
        this.targets = column;
        this.property = definition.property;
        this.name = this.property;
        if (isLabeledComponentDefinition(definition)) {
            if (definition.labelWidth == null) {
                definition.labelWidth = 0;
            }
        }
        this.definition = definition;
        this.orderable = definition.orderable;
        if (this.definition.nonEditableColumnDefinition != null) {
            switch (this.definition.nonEditableColumnDefinition.type) {
                case "DateColumn":
                    this.className = "c-datatable__date-column-cell";
                    break;
                case "NumberColumn":
                    this.className = "c-datatable__number-column-cell";
                    break;
                case "TextColumn":
                    this.className = "c-datatable__text-column-cell";
                    break;
            }
        }
    }

    public render = (data, type, row, meta) => {
        if (data === undefined) {
            data = null;
        }

        if (data != null && type === "display") {
            if (!this.mustRenderComponent(row)) {
                const customProperty = (this.definition.property !== this.definition.nonEditableColumnDefinition?.property);
                const roDef = { 
                    property: this.definition.property, 
                    ...this.definition.nonEditableColumnDefinition,
                    customProperty };
                const column = ColumnFactory.column(this.targets, roDef, this.table);
                return (column.render as DataTables.FunctionColumnRender)(data, type, row, meta);
            }
        }
        return data;
    }

    private mustRenderComponent(rowData): boolean {
        if (this.definition.editableProperty != null
            && this.table.getValueForFieldInRow(this.definition.editableProperty, rowData)) {
            return false;
        }
        return true;
    }
}


export function isComponentColumnDefinition(arg: any): arg is ComponentColumnDefinition {
    return arg.component !== undefined && arg.type === "ComponentColumn";
}

export interface ComponentColumnDefinition extends ColumnDefinition {
    component: ComponentDefinition;
    editableProperty?: string;
    nonEditableColumnDefinition?: ColumnDefinition;
    orderable?: boolean;
}
